import { useState, useEffect } from 'react';
import { fetchStatuses, createStatus, updateStatus, deleteStatus } from '../services/statusService';

export const useStatuses = () => {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadStatuses = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchStatuses();
      setStatuses(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const addStatus = async (statusData) => {
    try {
      setError(null);
      const newStatus = await createStatus(statusData);
      setStatuses(prev => [...prev, newStatus]);
      return newStatus;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const editStatus = async (id, statusData) => {
    try {
      setError(null);
      const updatedStatus = await updateStatus(id, statusData);
      setStatuses(prev => prev.map(status => status.id === id ? updatedStatus : status));
      return updatedStatus;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const removeStatus = async (id) => {
    try {
      setError(null);
      await deleteStatus(id);
      setStatuses(prev => prev.filter(status => status.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  useEffect(() => {
    loadStatuses();
  }, []);

  return {
    statuses,
    loading,
    error,
    loadStatuses,
    addStatus,
    editStatus,
    removeStatus
  };
};